import { render } from "./SystemTriggerPanel.vue?vue&type=template&id=d565b68a"
import script from "./SystemTriggerPanel.vue?vue&type=script&lang=js"
export * from "./SystemTriggerPanel.vue?vue&type=script&lang=js"

import "./SystemTriggerPanel.vue?vue&type=style&index=0&id=d565b68a&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__